import { useNavigate } from "react-router-dom"
export default function Home3() {
  const navigate=useNavigate();
const handleClick = () => {
  navigate('/ContactUs');
};

  const faqs = [
    {
      idx:'01',
      question: "Exclusive, never-shared leads",
    },
    {
      idx:'02',
      question: "100% compliant, ethical marketing",
    },
    {
      idx:'03',
      question: "Target clients in your chosen states",
    },
    {
      idx:'04',
      question: "Proven results across accident cases",
    }
  ]

  return (
    <div className="bg-stone-100 px-4 py-12 md:px-8 lg:px-16">
      <div className="mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <h1 className="text-[60px] font-[700] leading-[60px] text-[#0A476C] mb-6" style={{ fontFamily: 'Futura Bold, Futura, sans-serif' }}>
            Injured in an Accident?
          </h1>
          <p className="text-[21px] text-[#3A5579] max-w-4xl mx-auto leading-relaxed" style={{ fontFamily: 'Avenir Book, Avenir, sans-serif' }}>
            Whether it's a car, truck, motorcycle, or rideshare accident, we're here to help you understand your legal rights and navigate the claims process.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8 lg:gap-12">
          {faqs.map((faq, index) => (
            <div key={index} className="flex items-start gap-4 ml-[15%]">
              <div className="flex-shrink-0">
                <div className="w-8 h-8 bg-[#FC821F] rounded-full flex items-center justify-center">
                  <span className="text-white font-bold text-lg">
                    {faq.idx}
                  </span>
                </div>
              </div>
              <div className="flex-1">
                <p
                  className="text-[21px] text-[#0A476C] leading-relaxed"
                  style={{ fontFamily: 'Avenir Book, Avenir, sans-serif' }}
                >
                  {faq.question}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="flex items-center justify-center mt-5">
          <div className="flex flex-col sm:flex-row gap-4">
            <button 
            onClick={handleClick}
            className="bg-[#FC821F] border-2 border-[#FC821F]  hover:bg-white hover:text-[#FC821F]  text-[#FFFFFF] font-semibold px-8 py-3 rounded-md text-lg transition-colors duration-200">

              Let’s Grow Your Firm
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
